import { getGoogleAuthStartUrl, getGoogleLogoutUrl } from '@/services/server/users'

export const startGoogleAuth = (redirectUrl = '/dashboard') => {
    window.location.href = getGoogleAuthStartUrl(redirectUrl)
}

const SILENT_CHECK_KEY = 'kidon_sso_silent_check_at'
const SILENT_CHECK_GAP_MS = 15_000

/** False when a silent check ran a moment ago, so a token that keeps failing cannot bounce the page forever. */
export const shouldTrySilentGoogleAuth = (now = Date.now()) => {
    try {
        const last = Number(window.sessionStorage.getItem(SILENT_CHECK_KEY))
        return !last || now - last > SILENT_CHECK_GAP_MS
    } catch {
        return true
    }
}

export const markSilentGoogleAuth = () => {
    try {
        window.sessionStorage.setItem(SILENT_CHECK_KEY, String(Date.now()))
    } catch {
        // No session storage: the check still runs, only the loop guard is off.
    }
}

/** Signs in without a click when the user already logged into Kidon, SpotPress or another linked app. */
export const startSilentGoogleAuth = (redirectUrl = '/dashboard') => {
    markSilentGoogleAuth()
    window.location.replace(getGoogleAuthStartUrl(redirectUrl, { silent: true }))
}

/** Ends the shared login too. Without it the sign-in page would sign the user straight back in. */
export const endGoogleSession = () => {
    markSilentGoogleAuth()
    window.location.href = getGoogleLogoutUrl()
}

/** @deprecated Legacy step-up 2FA for password login */
export const get2FA = () => {
    window.location.href = `${import.meta.env.VITE_SERVER_BASE_URL}/google/2fa/start`
}
